/**
 * Created by qlong on 9/12/2016.
 */

export function onFileLoad(fileData){
    return {
        type: "ON_FILE_LOAD",
        payload: fileData,
    }
}

export function onFileChange(){
    return {
        type: "ON_FILE_CHANGE",
        payload: null,
    }
}



/** WEBPACK FOOTER **
 ** ./src/actions/fileDataActions.js
 **/